export const HOUSING_EXPENSE_TOTAL_LABEL = 'Housing Expense (DTI):';

export const housingExpenseRows = [
  { label: 'PITI', valueKey: 'piti' },
  { label: 'Lot Rent', valueKey: 'monthlyLotRent' },
  { label: 'Land Payment', valueKey: 'landMonthlyPayment' },
];
